import State from '../core/State';
import initialState from '../initialState';
import User from '../entity/User';

export const startFetchingUser = () => (state: State): State => ({
  ...state,
  user: {
    ...state.user,
    fetching: state.user.fetching + 1,
  },
});

export const finishFetchingUser = () => (state: State): State => ({
  ...state,
  user: {
    ...state.user,
    fetching: state.user.fetching - 1,
  },
});

export const setUser = (user: User) => (state: State): State => ({
  ...state,
  user: {
    ...state.user,
    data: user,
  },
});

export const disposeUser = () => (state: State): State => ({
  ...state,
  user: initialState.user,
});

export const setPublic = (isPublic: boolean) => (state: State): State => ({
  ...state,
  user: {
    ...state.user,
    isPublic: isPublic,
  },
});
